import { render } from "./EditCourse.vue?vue&type=template&id=0dd46d14&ts=true"
import script from "./EditCourse.vue?vue&type=script&lang=ts"
export * from "./EditCourse.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__